import { type TFunction } from 'i18next';

import { localizeTournamentName } from 'app/i18n/utils';
import { sort } from 'app/utils/array';

const orderSeriesTournaments = (
  t: TFunction,
  tournaments: SeriesTournament[]
): SeriesTournament[] =>
  // first sort by begin_at
  sort(tournaments, tournament => tournament.begin_at)
    .sort((a, b) => {
      // Sort by name. Don't sort if the compared tournaments have different names. But if the two tournaments start with "Group" then sort alphabetically.
      if (!a.name.toLowerCase().startsWith('group') || !b.name.toLowerCase().startsWith('group')) {
        return 0;
      }
      return a.name.localeCompare(b.name);
    })
    .map(tournament => ({
      ...tournament,
      name: localizeTournamentName(t, tournament.name)
    }));

const getFirstSelectedTournament = (
  tournaments: SeriesTournament[]
): SeriesTournament | undefined => {
  if (tournaments.length === 0) {
    return undefined;
  }

  // Tournaments are already ordered by begin_at
  const ongoingTournament = tournaments.find(tournament => tournament.status === 'running');
  if (ongoingTournament) {
    return ongoingTournament;
  }

  const upcomingTournaments = tournaments.filter(tournament => tournament.status === 'upcoming');
  if (upcomingTournaments.length > 0) {
    return upcomingTournaments[0];
  }

  const tournamentsOrderedByEndDate = sort(tournaments, tournament => tournament.end_at);
  return tournamentsOrderedByEndDate.at(-1) ?? tournaments[0];
};

export { orderSeriesTournaments, getFirstSelectedTournament };
